import _ceil from 'lodash/ceil';
import _orderBy from 'lodash/orderBy';
import dao from '../../../../dao/smbpartner/financeDao';
import smbUtils from '../../../../utils/smbUtils';
import dayjs from 'dayjs';

const LIST_PAYOUTS = 'pages/partner/finance/history/LIST_PAYOUTS';
const LIST_PAYOUTS_SUCCESS =
  'pages/partner/finance/history/LIST_PAYOUTS_SUCCESS';
const FILTER_PAYOUTS = 'pages/partner/finance/history/FILTER_PAYOUTS';
const FILTER_PAYOUTS_SUCCESS =
  'pages/partner/finance/history/FILTER_PAYOUTS_SUCCESS';
const SEARCH = 'pages/partner/finance/history/SEARCH';
const RESET_SEARCH = 'pages/partner/finance/history/RESET_SEARCH';
const PAGE = 'pages/partner/finance/history/PAGE';
const SIZE = 'pages/partner/finance/history/SIZE';
const SORT = 'pages/partner/finance/history/SORT';

const initialState = {
  payouts: [],
  allPayouts: [],
  isLoaded: true,
  grid: {
    sort: 'requestTime',
    asc: false,
    pageIndex: 1,
    pageSize: 10,
    querySize: 100,
    pages: 1,
    totalSize: 0,
  },
  searchParams: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LIST_PAYOUTS:
      return {
        ...state,
      };
    case LIST_PAYOUTS_SUCCESS:
      return {
        ...state,
        payouts: action.json.results,
        allPayouts: action.json.results,
      };
    case FILTER_PAYOUTS:
      return {
        ...state,
      };
    case FILTER_PAYOUTS_SUCCESS:
      return {
        ...state,
        payouts: action.json,
        grid: {
          ...state.grid,
          totalSize: action.json.length,
          pages: _ceil(action.json.length / state.grid.pageSize),
        },
      };
    case SEARCH:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.params,
        },
        grid: {
          ...state.grid,
          pageIndex: 1,
        },
      };
    case RESET_SEARCH:
      return {
        ...state,
        searchParams: {},
      };
    case PAGE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageIndex: action.pageIndex,
        },
      };
    case SIZE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageSize: action.pageSize,
          pages: _ceil(state.allPayouts.length / action.pageSize),
          pageIndex: 1,
        },
      };
    case SORT:
      return {
        ...state,
        grid: {
          ...state.grid,
          sort: action.sort,
          asc: state.grid.sort === action.sort ? !state.grid.asc : false,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export function listPayouts() {
  return (dispatch, getState) => {
    dispatch({
      type: LIST_PAYOUTS,
    });
    return dao
      .listAllPayouts(buildQueryString(getState()))
      .then(json => dispatch(listPayoutsSuccess(json)));
  };
}

function listPayoutsSuccess(json) {
  return dispatch => {
    dispatch({
      type: LIST_PAYOUTS_SUCCESS,
      json,
    });
    return dispatch(filterPayouts());
  };
}

function buildQueryString(rootState) {
  const grid = rootState.pages.partner.finance.history.grid;
  return {
    sortBy: grid.sort,
    asc: grid.asc,
    pageIndex: initialState.grid.pageIndex,
    pageSize: grid.querySize,
  };
}

function filterPayouts() {
  return (dispatch, getState) => {
    const grid = getState().pages.partner.finance.history.grid;
    let payouts = getState().pages.partner.finance.history.allPayouts;
    const filterParams = smbUtils.omit(
      getState().pages.partner.finance.history.searchParams
    );
    if (filterParams.payoutStatus && filterParams.payoutStatus !== 'ALL') {
      payouts = payouts.filter(p => {
        const pt = p.payoutStatus;
        return pt.search(new RegExp(filterParams.payoutStatus, 'i')) !== -1;
      });
    }
    if (filterParams.paymentType && filterParams.paymentType !== '') {
      payouts = payouts.filter(p => {
        const pt = p.paymentType;
        return pt.search(new RegExp(filterParams.paymentType, 'i')) !== -1;
      });
    }
    if (filterParams.requestTimeFrom) {
      payouts = payouts.filter(p => {
        const from = dayjs(filterParams.requestTimeFrom).valueOf();
        const to = dayjs(filterParams.requestTimeTo).valueOf();
        const requestTime = dayjs(p.requestTime).valueOf();
        return from <= requestTime && requestTime <= to;
      });
    }
    if (filterParams.payoutDateFrom) {
      payouts = payouts.filter(p => {
        const from = dayjs(filterParams.payoutDateFrom).valueOf();
        const to = dayjs(filterParams.payoutDateTo).valueOf();
        const payoutDate = dayjs(p.payoutDate).valueOf();
        return from <= payoutDate && payoutDate <= to;
      });
    }
    payouts = _orderBy(payouts, grid.sort, grid.asc ? 'asc' : 'desc');
    return dispatch(filterLinksSuccess(payouts));
  };
}

function filterLinksSuccess(json) {
  return {
    type: FILTER_PAYOUTS_SUCCESS,
    json,
  };
}

export function search(params) {
  return dispatch => {
    dispatch({
      type: SEARCH,
      params,
    });
    return dispatch(filterPayouts());
  };
}

export function resetSearch() {
  return dispatch => {
    dispatch({
      type: RESET_SEARCH,
    });
    return dispatch(filterPayouts());
  };
}

export function page(params) {
  return {
    type: PAGE,
    pageIndex: params.selected + 1,
  };
}

export function size(pageSize) {
  return {
    type: SIZE,
    pageSize,
  };
}

export function sort(sort) {
  return dispatch => {
    dispatch({
      type: SORT,
      sort,
    });
    return dispatch(filterPayouts());
  };
}
